import styled from 'styled-components';

export const CreativePreviewStyles = styled.div`
  .preview-date-container {
    display: flex;
    margin-top: 10px;
    margin-left: 20px;
    gap: 10px;
    align-items: center;

    .date-title {
      font-weight: bold;
    }

    .dropdown-item {
      &:active,
      &:focus,
      &:hover {
        background-color: inherit;
        color: inherit;
      }
    }
  }

  .preview-container {
    margin: 20px;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .bg-light {
    color: black;
  }

  .refetch-container {
    display: flex;
    font-weight: bold;
    gap: 5px;
    align-items: center;

    .refresh-icon {
      font-size: 1.2rem;
      cursor: pointer;
    }

    .spinner-border {
      height: 1rem;
      width: 1rem;
      border-width: 0.2em;
    }
  }
`;
